// extracted by mini-css-extract-plugin
export default {"eventPage__wrapper":"styles_eventPage__wrapper__R9WO3","eventPage__markets":"styles_eventPage__markets__slsyG","eventPage__divided":"styles_eventPage__divided__i6k4S"};